import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import _ from 'lodash'
import { useLocation } from 'react-router-dom'
import { SSFC } from "src/common/razzle-platform-components/types"
import { useIntl } from 'src/common/razzle-platform-translate'
import PageLoader from 'src/common/razzle-platform-components/PageLoader/PageLoader'
import { useWpPlugins, useScroll } from "src/common/razzle-platform-components/hooks"
import ProductMap from 'src/common/razzle-platform-map/Map/ProductsMap'
import { CategoriesOfProduct, Product, SpecificityOfProduct } from 'declarations'
import { useMobileDetector } from 'src/common/razzle-platform-components/hooks/mobile-detector'
import { SEOEnhancer } from 'src/common/razzle-platform-components/seo/SEOEnhancer'
import { useProducts } from 'src/common/razzle-platform-product/hooks'
import { getInitialPropsOfProducts } from 'src/common/razzle-platform-product/ssr'
import { useCategoriesOfProduct } from 'src/common/razzle-platform-categoryofproduct/hooks'
import { getInitialPropsOfCategoriesOfProduct } from 'src/common/razzle-platform-categoryofproduct/ssr'
import { useSpecificitiesOfProduct } from 'src/common/razzle-platform-specificityofproduct/hooks'
import { getInitialPropsOfSpecificitiesOfProduct } from 'src/common/razzle-platform-specificityofproduct/ssr'
import { ProductItem, ProductItemSkeleton } from 'src/modules/product/pages/ProductsList/components/ProductItem'
import PeriodicityFilter from 'src/modules/product/pages/ProductsList/components/PeriodicityFilter'


export const ProductsList: SSFC<{}> = (props) => {

    const { formatMessage } = useIntl()
    useWpPlugins()
    const location = useLocation()
    const { isMobile } = useMobileDetector()
    const { products, pagination, isFirstRequestInPregress, isUpdateProgress } = useProducts<Product>({ infiniteScroll: isMobile, useUrlParams: true, usePagination: true, params: { _per_page: '20', _sort: '-published_at' } })
    const { categoriesOfProduct } = useCategoriesOfProduct<CategoriesOfProduct>({ usePagination: false, useUrlParams: false })
    const { specificitiesOfProduct } = useSpecificitiesOfProduct<SpecificityOfProduct>()
    const dispatch = useDispatch()
    useScroll(isMobile ? undefined : isUpdateProgress)

    useEffect(() => {
        dispatch.userModel.fetchCurrentUser()
    }, [])

    if (!products || isFirstRequestInPregress || !categoriesOfProduct || ! specificitiesOfProduct) {
        return <PageLoader />
    }
    return (
        <>
            <SEOEnhancer
                title={formatMessage({
                    id: 'Tous les véhicules de la communauté - Swaptheroad!!',
                    defaultMessage: 'Tous les véhicules de la communauté - Swaptheroad!!'
                })}
                description={formatMessage({
                    id: 'Découvrez tous les véhicules des membres de la communauté Swaptheroad.',
                    defaultMessage: 'Découvrez tous les véhicules des membres de la communauté Swaptheroad.'
                })}
            />

            <div data-elementor-type="wp-page" data-elementor-id="5110" className="elementor elementor-5110" data-elementor-post-type="page">
                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-c657f23 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                    data-id="c657f23"
                    data-element_type="section"
                >
                <div className="elementor-container elementor-column-gap-default">
                    <ProductMap
                        listItem={ isUpdateProgress && !isMobile ? ProductItemSkeleton: ProductItem}
                        markerPreviwItem={null}
                        marker={null}
                        extraAvailabilityFilters={PeriodicityFilter}
                        products={products}
                        pagination={pagination}
                        categories={categoriesOfProduct}
                        specificities={specificitiesOfProduct}
                        updateInProgress={isUpdateProgress}
                    />
                </div>
                </section>
            </div>
        </>
    )

}


ProductsList.getServerSideProps = async (context, store) => {
    await getInitialPropsOfProducts(context, store, {
        useUrlParams: true, usePagination: true, params: { _per_page: '20', _sort: '-published_at' },
    })
    await getInitialPropsOfCategoriesOfProduct(context, store, { usePagination: false, useUrlParams: false })
    await getInitialPropsOfSpecificitiesOfProduct(context, store)
}
